import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-secondary'
    },
    buttonsStyling: false
  });

  constructor() { }

  /**
   * Show success notification
   */
  success(title: string, text?: string, timer: number = 3000): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: title,
      text: text,
      icon: 'success',
      timer: timer,
      showConfirmButton: false
    });
  }

  /**
   * Show error notification
   */
  error(title: string, text?: string): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: title,
      text: text,
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'OK'
    });
  }

  /**
   * Show info notification
   */
  info(title: string, text?: string): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: title,
      text: text,
      icon: 'info',
      showConfirmButton: true,
      confirmButtonText: 'OK'
    });
  }

  /**
   * Show warning notification
   */
  warning(title: string, text?: string): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: title,
      text: text,
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'OK'
    });
  }

  /**
   * Show confirmation dialog
   */
  confirm(title: string, text?: string, confirmButtonText: string = 'Yes', cancelButtonText: string = 'Cancel'): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: title,
      text: text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      reverseButtons: false
    });
  }

  /**
   * Show no internet connection notification (from UtilService pattern)
   */
  noInternet(): Promise<any> {
    return this.swalWithBootstrapButtons.fire({
      title: 'Oops! No Internet',
      text: "It seems that you are not connected to the internet. Please, connect and try again.",
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'OK',
      reverseButtons: false
    });
  }

  /**
   * Show custom notification with full configuration
   */
  custom(config: any): Promise<any> {
    return Swal.fire(config);
  }

  /**
   * Toast notification (bottom-right corner)
   */
  toast(icon: 'success' | 'error' | 'warning' | 'info', title: string, timer: number = 3000): Promise<any> {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });

    return Toast.fire({
      icon: icon,
      title: title
    });
  }
}